import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "Attachments" */ './lazyIndex');
});
// Delayed Loaded Components
export var AttachmentWellView = createLazyComponent(lazyModule, function (m) { return m.AttachmentWellView; });
//# sourceMappingURL=index.js.map